


















































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { User } from '@/store/profile/types';
import { Wallet } from '@/store/wallet/types';
import { MangoPayMandates, BankAccount } from '@/store/mangoPay/types';
import { extendedDate } from '@/filters/date';
import Modal from '@/components/_common/Modal.vue';
import BankAccountListSelector from '@/components/bankAccount/shared/BankAccountListSelector.vue';
import WalletDetails from '@/components/wallet/shared/WalletDetails.vue';
import ExporoTooltip from '@/components/_common/Tooltip.vue';

import { MandateStatus } from '@/enum/mangoPay/MandateTypes';

@Component({
  name: 'charge-wallet',
  components: {
    BankAccountListSelector,
    ExporoTooltip,
    Modal,
    WalletDetails,
  },
  filters: {
    extendedDate,
  },
})
export default class ChargeWallet extends Vue {
  @Prop({ required: true }) wallet: Wallet;
  @Prop({ required: true }) mandates: MangoPayMandates;
  @Prop({ required: true }) createPayIn: Function;
  @Prop({ required: true }) user: User;
  @Prop({ required: true }) bankAccounts: Array<BankAccount>;

  private paymentType: string = 'SEPA_TRANSFER';
  private selectedBankAccount: string = null;
  private selectedBankAccountMandate: string = null;
  private statementDescriptor: string = '';
  private debitAmount: number = null;
  private error: boolean = false;
  private resultMessage: string = '';
  private isLoading: boolean = false;

  /*
  mounted() {
    this.checkBankAccounts();
  }

  @Watch('bankAccounts')
  onPropertyChanged(value: Array<BankAccount>) {
    this.checkBankAccounts();
  }

  checkBankAccounts() {
    if (this.bankAccounts && this.bankAccounts.length === 1) {
      this.onBankSelect(this.bankAccounts[0].Id);
    }
  }
  */

  get hasResultMessage() {
    return this.resultMessage != '';
  }
  get isSEPATransfer() {
    return this.paymentType === 'SEPA_TRANSFER';
  }

  get isSEPADebit() {
    return this.paymentType === 'SEPA_DEBIT';
  }

  /*
  get canSubmit() {
    return (
      this.selectedBankAccountMandate &&
      this.selectedBankAccount &&
      this.debitAmount &&
      this.debitAmount > 0
    );
  }
  */

  setSEPATransfer() {
    this.paymentType = 'SEPA_TRANSFER';
  }

  setSEPADebit() {
    // this.paymentType = 'SEPA_DEBIT';
  }

  onStatementDescriptorChange() {
    this.statementDescriptor = this.statementDescriptor.replace(
      /[^0-9a-z\s]/gi,
      ''
    );
  }

  /*
  onBankSelect(bankAccountId: string) {
    this.selectedBankAccount = bankAccountId;

    const bankAccount = this.bankAccounts.find(
      (account) => account.Id === bankAccountId
    );
    this.error = false;
    this.resultMessage = '';
    const mandate = this.mandates[bankAccountId];

    if (!bankAccount.Active) {
      this.error = true;
      this.selectedBankAccountMandate = null;
      this.resultMessage = this.$t('chargeWallet.error', {
        context: 'disabled',
      });
    } else if (!mandate || mandate.Status === MandateStatus.FAILED) {
      this.error = true;
      this.selectedBankAccountMandate = null;
      this.resultMessage = this.$t('chargeWallet.error', {
        context: 'mandate',
      });
    } else {
      this.selectedBankAccountMandate = mandate.Id;
    }
  }

  onSubmit() {
    this.error = false;
    this.resultMessage = '';
    this.isLoading = true;
    const payload = {
      amount: parseInt((this.debitAmount * 100).toFixed()),
      mandateId: this.selectedBankAccountMandate,
      statementDescriptor: this.statementDescriptor,
    };

    this.createPayIn(payload)
      .then((response) => {
        this.$router.push('/');
      })
      .catch((err) => {
        this.error = true;
        const result = err.response?.data;
        if (result?.Type === 'idempotent_creation_conflict') {
          this.resultMessage = this.$t('chargeWallet.error', {
            context: 'idempotency',
            labelDescriptor: this.$t('chargeWallet.label', {
              context: 'statementDescriptor',
            }),
          });

          return;
        }

        this.resultMessage = this.$t('forms.error', { context: 'generic' });
      })
      .finally(() => (this.isLoading = false));
  }
  */

  onClose() {
    this.error = false;
    this.resultMessage = '';
  }
}
